/**
 * What goes wrong on the access steps, in production's words.
 *
 * Copied from main rather than written here, because these are the messages the
 * API actually produces and the flow has to survive: `VerifyAccess.tsx` (work
 * email and partner code) and `EnterInviteCode.tsx` (the payroll id, which
 * production submits as an invite key). Reworking the screens does not rewrite
 * the failures, so anything reworded here would be a design pretending the
 * back end had changed.
 *
 * Where main raises these as a toast and the screens below show them under the
 * field, the copy is the same; only where it lands has moved.
 */
export const ACCESS_ERRORS = {
  /** Register-by-domain rejected the address. */
  workEmailUnknown:
    "We don't recognise that work email. Please check and try again.",
  /** Register-by-domain answered with something unusable. */
  workEmailUnexpected:
    'We received an unexpected response when requesting a verification code, please try again',
  /** The code is not one we issued, or it is spent. */
  partnerCodeInvalid: 'Invalid code. Please check and try again.',
  /** Arrived on a partner link carrying a code that no longer works. */
  partnerCodeFromLink:
    'The partner code in your link is invalid or has already been used. Please check with your partner.',
  /** 5xx from the code check. */
  partnerCodeServer: 'Something went wrong. Please try again later.',
  /** Not six characters. Production checks the length before it checks the code. */
  payrollIdLength: 'Please enter a valid invite code (6 digits)',
  /** Six characters, but not the ones we emailed. */
  payrollIdWrong:
    'The code you entered is incorrect. Please ensure you are using the invite code provided in your work email inbox with the subject: "Your KareHero work email verification code is ●●●●●●"',
};
